import React, { useState } from "react";
import { MessageCircle, X, Send } from "lucide-react";

export default function ChatBubble() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: "Hi! \ud83d\udc4b Welcome to Keto Ambrosia. How can we help you today?",
    },
  ]);
  const [input, setInput] = useState("");

  const send = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    setMessages((m) => [...m, { from: "user", text: input }]);
    const txt = input;
    setInput("");
    setTimeout(() => {
      setMessages((m) => [
        ...m,
        {
          from: "bot",
          text:
            "Thanks for the message! Our team will reach out shortly. For urgent orders, please call +91 98408 58201.",
        },
      ]);
    }, 700);
  };

  return (
    <>
      {open && (
        <div className="fixed bottom-24 right-6 w-[320px] max-w-[calc(100vw-32px)] bg-white shadow-2xl rounded-lg overflow-hidden z-40 fade-in border border-gray-100">
          <div className="bg-[var(--ka-teal)] text-white px-4 py-3 flex items-center justify-between">
            <div>
              <div className="font-medium text-sm">Let&apos;s Chat</div>
              <div className="text-[11px] text-white/70">
                We typically reply within minutes
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-white/80 hover:text-white"
              aria-label="Close chat"
            >
              <X size={18} />
            </button>
          </div>
          <div className="p-3 h-64 overflow-y-auto space-y-2 bg-[var(--ka-cream)]">
            {messages.map((m, i) => (
              <div
                key={i}
                className={`max-w-[80%] text-sm px-3 py-2 rounded-lg ${
                  m.from === "bot"
                    ? "bg-white text-[var(--ka-text)] self-start"
                    : "bg-[var(--ka-teal)] text-white ml-auto"
                }`}
              >
                {m.text}
              </div>
            ))}
          </div>
          <form
            onSubmit={send}
            className="p-2 flex items-center gap-2 border-t border-gray-100"
          >
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              type="text"
              placeholder="Type a message..."
              className="flex-1 outline-none text-sm py-2 px-3 bg-gray-50 rounded-md"
            />
            <button
              type="submit"
              className="w-9 h-9 rounded-md bg-[var(--ka-teal)] text-white inline-flex items-center justify-center hover:bg-[var(--ka-teal-dark)] transition"
            >
              <Send size={16} />
            </button>
          </form>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        className="chat-bubble"
        aria-label="Open chat"
      >
        <MessageCircle size={18} />
        <span className="hidden sm:inline">Let&apos;s Chat!</span>
      </button>
    </>
  );
}
